import { useLayoutEffect, useRef, useState } from "react";

// Google Sign-In dugmesi CSS genisligini dinlemez; iframe'e `width` prop'u
// olarak PIKSEL verilmesi gerekir. Kap genisligini olcup ResizeObserver ile
// canli tutar; boylece dugme dar ekranda formdan tasmaz.
export default function useElementWidth(max = 400) {
  const ref = useRef(null);
  const [width, setWidth] = useState(max);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => {
      const w = Math.floor(el.getBoundingClientRect().width);
      if (w > 0) setWidth(Math.min(max, w));
    };
    measure();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => window.removeEventListener("resize", measure);
    }
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [max]);

  return [ref, width];
}
